<script>
import Auth from '@/pages/layouts/auth.vue';
import {useForm} from "@inertiajs/vue3";
import {Link} from "@inertiajs/vue3";
import Input from "@/pages/components/form/vertical/input.vue";

export default {
  components: {
    Auth,
    Input,
    Link
  },

  data() {
    return {
      form: useForm({
        email: '',
      })
    }
  },
  methods: {
    submit() {
      this.form.post(route('password.email'));
    }
  }
}
</script>

<template>
  <Auth title="Wachtwoord vergeten">
    <div v-if="!form.wasSuccessful">
      <p>
        Je wachtwoord vergeten? Geen probleem. Laat ons uw e-mailadres weten en wij sturen u een e-mail met een wachtwoordreset
        link waarmee u een nieuwe kunt kiezen.
      </p>

      <form class="form-horizontal form-material" @submit.prevent="submit">
        <Input :form="form" v-model="this.form.email" name="email" type="email" required autofocus autocomplete="username" placeholder="E-mail"/>

        <div class="form-group">
          <button :disabled="form.processing" class="btn w-100 btn-lg btn-primary btn-rounded text-white" type="submit">Verstuur reset link</button>
        </div>
      </form>
    </div>


    <div v-if="form.wasSuccessful">
      <p>
        Er is een reset-link verstuurd naar het door u gegeven e-mailadres.
      </p>
    </div>

    <Link :href="route('login')"><i class="bi bi-arrow-left"></i> Terug naar het inlogscherm</Link>
  </Auth>
</template>